module.exports = __webpack_public_path__ + "static/media/xk.62bc9bcf.svg";